import pageTitle from 'ember-page-title/helpers/page-title';
import Layout from 'parog-web/components/legal-info/layout';
const MyTemplate: TOC<{ Args: { model: unknown; controller: unknown } }> =
  <template>
    {{pageTitle 'Informations légales'}}

    <Layout />
  </template>;

import type { TOC } from '@ember/component/template-only';

export default MyTemplate;
